var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-items-center justify-content-center",attrs:{"id":"confirmation-page"}},[_c('div',{staticStyle:{"max-width":"560px"}},[_c('logo'),_c('p',{staticClass:"h5 my-4"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }